import { useAppSelector } from '../../store/hooks'

export const useOrganisations = () => {
  const organisations = useAppSelector((state) => state.organisations)
  return organisations
}
